import { render } from "./I18nTranslationsList.vue?vue&type=template&id=1302b77f"
import script from "./I18nTranslationsList.vue?vue&type=script&lang=js"
export * from "./I18nTranslationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__